import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../app/hooks';
import { TypeErrorResponse } from './constants';
import { showToastMessage } from '../features/generalSlice';

const useErrorToast = () => {
    const dispatch = useAppDispatch()
    const dispatchErrorMessage=(error: any)=>{
        error = error as AxiosError;
        let message =""
        if (error.response) {
            const data = error.response.data as TypeErrorResponse
            message = data.message;
        } else {
            message = "Something went wrong"
        }
        dispatch(showToastMessage({
            message: message,
            type: "error",
            position: toast.POSITION.TOP_RIGHT
        }));
    }
    return dispatchErrorMessage;
};

export default useErrorToast;
